{
  "title": "帳戶與個人檔案",
  "languageSection": "語言與地區",
  "preferredLanguage": "偏好語言",
  "preferredLanguageHelp": "適用於整個網站，以及我們發送給你的電郵。",
  "profile": "公開檔案",
  "notifications": "通知",
  "emailPreferences": "電郵偏好設定"
}
